export default __webpack_public_path__ + "static/media/register.c6472c10.svg";